























import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import { GET_PAYMENT_METHOD } from './getPaymentMethod';
import PaymentMethodForm from '@/components/PaymentMethod/PaymentMethodForm.vue';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { GQL_updatePaymentMethod } from '@/queries/__generated__/updatePaymentMethod';
import gql from 'graphql-tag';

const UPDATE_PAYMENT_METHOD = gql`
  mutation updatePaymentMethod($paymentMethod: PaymentMethodUpdate!) {
    updatePaymentMethod(input: { paymentMethod: $paymentMethod }) {
      paymentMethod {
        id
        name
      }
    },
  },
`;

@Component({
  components: {
    PaymentMethodForm,
  },
})
export default class PaymentMethodEdit extends Vue {
  @Prop([ Number, String ]) private id!: number | string;
  private GET_PAYMENT_METHOD = GET_PAYMENT_METHOD;
  private UPDATE_PAYMENT_METHOD = UPDATE_PAYMENT_METHOD;

  @Emit()
  private paymentMethodUpdated(store: InMemoryCache, query: { data: GQL_updatePaymentMethod }) {
    return query.data.updatePaymentMethod && query.data.updatePaymentMethod.paymentMethod;
  }
}
